
export const resolveUpgrades = () => {
    return ['eventsService', (eventsService) => {
        return eventsService.collectUpgrades().then(list => list);
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/resolvers/upgrades.resolver.js